// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"d7b15e50e9b092af","965":"00fdcd32e1933628"}[chunkId] + ".css";
};